import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';
import {
  UserInteractor,
  UserInteractorType,
  WorkTableType,
} from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

export class OpenTimeBoardCommand extends CategoryCommand<void> {
  constructor(
    commandImpl: CategoryCommandImpl<void>,
    private caption?: string
  ) {
    super(commandImpl);
  }
  public async getCaption(): Promise<Caption> {
    return this.caption
      ? {
          type: CaptionType.EXTERNAL,
          caption: this.caption,
        }
      : {
          type: CaptionType.BUILT_IN,
          caption: BuiltinCaptionType.TIME_BOARD,
        };
  }

  public getIcon(): IconName {
    return 'calendar';
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.WORK_TABLE,
      tableType: WorkTableType.TIME_BOARD,
    };
  }

  public getName(): CommandName {
    return 'openTimeBoard';
  }
}
